export const state = {
  notifications: [],
  notification_count: 0,
  notification_count_seen: 0,
};
